import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MaterialModule } from '../../shared/material.module';
// import { TreeviewModule } from '@samotics/ngx-treeview';
import { DndModule } from 'ngx-drag-drop';
import {
    SettingsIndexComponent,
    SettingsHeaderComponent,
    SettingsSubHeaderComponent,
    SettingsIdmsComponent,
    SettingsInformateComponent,
    SettingsProfileComponent,
    DefaultUnitsComponent,
    CalculationPreferencesComponent,
    CalculationPreferencesPassPctComponent,
    CalculationPreferencesCalcResultsComponent,
    CalculationPreferencesOtherComponent,
} from './components/index';
import { SettingsLanguageComponent } from './components/settings-general/settings-language/settings-language.component';
import { SharedContentAddUpdateComponent } from './components/settings-general/shared-content-add-update/shared-content-add-update.component';
import { SharedContentListComponent } from './components/settings-general/shared-content-list/shared-content-list.component';
import { SharedContentRemoveComponent } from './components/settings-general/shared-content-remove/shared-content-remove.component';
import { DataRestoreTableComponent } from './components/settings-idms/components/data-restore-table/data-restore-table.component';
import { DataTableComponent } from './components/settings-idms/components/data-table/data-table.component';
import { DesignTableComponent } from './components/settings-idms/components/design-table/design-table.component';
import { DetailsTableComponent } from './components/settings-idms/components/details-table/details-table.component';

import { DataViewComponent } from './components/settings-informate/components/data-view/data-view.component';
import { InstanceSidebarComponent } from './components/settings-informate/components/instance-sidebar/instance-sidebar.component';
import { SettingsGeneralComponent } from './components/settings-general/settings-general/settings-general.component';
import { SecurityLevel } from '../../models/enums/security-level.enum';
import { HomeModule } from '../home/home.module';
import { InstanceConfigurationComponent } from './components/settings-informate/components/instance-configuration/instance-configuration.component';
import { InstanceDataComponent } from './components/settings-informate/components/instance-data/instance-data.component';
import { UserPersonalDetailsComponent } from './components/settings-profile/components/user-personal-details/user-personal-details.component';
import { UserProfileWizardComponent } from './components/settings-profile/components/user-profile-wizard/user-profile-wizard.component';
import { PassLabelPipe } from './core/Pipes/pass-label.pipe';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { AvatarModule } from 'ngx-avatars';
import { TranslocoModule } from '@jsverse/transloco';
import { UserEmailNotificationDetailsComponent } from './components/settings-profile/components/user-email-notification-details/user-email-notification-details.component';
import { CommunicationsComponent } from './components/settings-profile/components/communications/communications.component';
import { AddUpdateCommunicationComponent } from './components/settings-profile/components/add-update-communication/add-update-communication.component';
// import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { PipeCodesComponent } from './components/settings-idms/components/pipe-codes/pipe-codes.component';
import { AddCombinationComponent } from './components/settings-idms/components/add-combination/add-combination.component';
import { AddPipeSpecComponent } from './components/settings-idms/components/add-pipe-spec/add-pipe-spec.component';
import { PipeSpecificationCodeComponent } from './components/settings-idms/components/pipe-specification-code/pipe-specification-code.component';
import { InformateModule } from '../informate/informate.module';
import { CalculationTypeComponent } from './components/settings-idms/components/calculation-type/calculation-type.component';
import { PermitWashersComponent } from './components/settings-idms/components/permit-washers/permit-washers.component';
import { DbSelectLookupMaterialAliasComponent } from './components/settings-idms/components/db-select-lookup-material-alias/db-select-lookup-material-alias.component';
import { MaterialListComponent } from './components/settings-idms/components/material-list/material-list.component';
import { AddUpdateDBLookUpFieldComponent } from './components/settings-idms/components/add-update-db-look-up-field/add-update-db-look-up-field.component';
import { PipeCodeGeneralComponent } from './components/settings-idms/components/pipe-code-general/pipe-code-general.component';
import { ApprovalsContentComponent } from './components/settings-idms/components/approvals-content/approvals-content.component';
import { AddNewRuleComponent } from './components/add-new-rule/add-new-rule.component';
import { AllocateviewdialogComponent } from './components/settings-idms/components/allocate-view-dialog/allocate-view-dialog.component';
import { AllocateFromViewComponent } from './components/settings-idms/components/allocate-from-view/allocate-from-view.component';
import { CommunicationDropdownComponent } from './components/settings-profile/components/communication-dropdown/communication-dropdown.component';
import { RulesApprovalsComponent } from './components/settings-idms/components/rules-approvals/rules-approvals.component';
import { RulesSidebarComponent } from './components/settings-idms/components/rules-sidebar/rules-sidebar.component';
import { RulesContentComponent } from './components/settings-idms/components/rules-content/rules-content.component';
import { UploadsComponent } from './components/settings-idms/components/uploads/uploads.component';
import { BarCodeQrCodeComponent } from './components/settings-idms/components/bar-code-qr-code/bar-code-qr-code.component';
import { DataUploadsComponent } from './components/data-uploads/data-uploads.component';
import { DownloadTreeNodeComponent } from './components/tree-node/download-tree-node.component';
import { UploadTreeNodeComponent } from './components/upload-tree-node/upload-tree-node.component';
import { BatchCalculationStatusComponent } from './components/settings-idms/components/batch-calculation-status/batch-calculation-status.component';
import { SharedModule } from 'src/app/shared/shared.module';

import { DxCheckBoxModule, DxHtmlEditorModule, DxSelectBoxModule, DxTreeListModule } from 'devextreme-angular';
import { DateProviders } from '../idms/core/custom-date-adapter';
import { SharedPipeModule } from 'src/app/shared/shared-pipe.module';
import { ApprovalRequestComponent } from './components/settings-idms/components/approval-request/approval-request.component';
import { CompletedApprovalsComponent } from './components/settings-idms/components/completed-approvals/completed-approvals.component';
import { AddDeliveryGroupModalComponent } from './components/add-delivery-group-modal/add-delivery-group-modal.component';
import { ApproveActionsModalComponent } from './components/settings-idms/components/approve-actions-modal/approve-actions-modal.component';

@NgModule({
    declarations: [
        SettingsIndexComponent,
        SettingsHeaderComponent,
        SettingsSubHeaderComponent,
        SettingsGeneralComponent,
        SettingsIdmsComponent,
        SettingsInformateComponent,
        SettingsProfileComponent,
        DetailsTableComponent,
        DesignTableComponent,
        DataTableComponent,
        DataRestoreTableComponent,
        InstanceSidebarComponent,
        DataViewComponent,
        DefaultUnitsComponent,
        CalculationPreferencesComponent,
        CalculationPreferencesPassPctComponent,
        CalculationPreferencesCalcResultsComponent,
        CalculationPreferencesOtherComponent,
        SharedContentListComponent,
        SettingsLanguageComponent,
        SharedContentAddUpdateComponent,
        SharedContentRemoveComponent,
        InstanceConfigurationComponent,
        InstanceDataComponent,
        UserPersonalDetailsComponent,
        UserProfileWizardComponent,
        PassLabelPipe,
        UserEmailNotificationDetailsComponent,
        CommunicationsComponent,
        AddUpdateCommunicationComponent,
        CommunicationDropdownComponent,
        PipeCodesComponent,
        AddCombinationComponent,
        AddPipeSpecComponent,
        PipeSpecificationCodeComponent,
        CalculationTypeComponent,
        PermitWashersComponent,
        DbSelectLookupMaterialAliasComponent,
        MaterialListComponent,
        AddUpdateDBLookUpFieldComponent,
        PipeCodeGeneralComponent,
        ApprovalsContentComponent,
        AddNewRuleComponent,
        AllocateFromViewComponent,
        AllocateviewdialogComponent,
        CommunicationDropdownComponent,
        RulesApprovalsComponent,
        RulesSidebarComponent,
        RulesContentComponent,
        UploadsComponent,
        BarCodeQrCodeComponent,
        DataUploadsComponent,
        DownloadTreeNodeComponent,
        UploadTreeNodeComponent,
        BatchCalculationStatusComponent,
        RulesApprovalsComponent,
        AddDeliveryGroupModalComponent,
        ApprovalRequestComponent,
        CompletedApprovalsComponent,
        ApproveActionsModalComponent,
        // CustomDateFormatPipe,
        //  CustomDateTimeFormatPipe,
    ],
    imports: [
        DndModule,
        CommonModule,
        MaterialModule,
        FormsModule,
        HomeModule,
        ReactiveFormsModule,
        FileUploadModule,
        SelectButtonModule,
        AvatarModule,
        TranslocoModule,
        InformateModule,
        RouterModule.forChild([
            { path: 'general', component: SettingsGeneralComponent, canActivate: [AuthGuard] },
            { path: 'idms', component: SettingsIdmsComponent, canActivate: [AuthGuard] },
            { path: 'informate', component: SettingsInformateComponent, canActivate: [AuthGuard] },
            { path: 'profile', component: SettingsProfileComponent, canActivate: [AuthGuard] },
        ]),
        // TreeviewModule.forRoot(),
        // NgxMatDatetimePickerModule,
        // NgxMatNativeDateModule,
        SharedModule,
        DxTreeListModule,
        SharedPipeModule,
        DxHtmlEditorModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        // ApprovalRequestComponent,
    ],
    exports: [
        SettingsGeneralComponent,
        SettingsIdmsComponent,
        SettingsInformateComponent,
        SettingsProfileComponent,
        InstanceConfigurationComponent,
        InstanceDataComponent,
        InstanceSidebarComponent,
        AllocateFromViewComponent,
        PipeCodeGeneralComponent,
        PipeCodesComponent,
        SelectButtonModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [DateProviders],
})
export class SettingsModule {}
